import odata from 'odata-client';
import {
  UPDATE_CUSTOMER_REQUEST,
  UPDATE_CUSTOMER_ERROR,
  UPDATE_CUSTOMER_SUCCESS,
  TOKEN_EXPIRED
} from '../types';
import { getServiceUrl, getDefaultHeader } from '../../utils';
import RESOURCES from '../../api/resources';
import { showNotification } from '../notification';

export const tokenExpired = () => ({
  type: TOKEN_EXPIRED
});

export const updateCustomerRequest = () => ({
  type: UPDATE_CUSTOMER_REQUEST
});

export const updateCustomerError = errorOrResults => ({
  type: UPDATE_CUSTOMER_ERROR,
  error: errorOrResults.message
});

export const updateCustomerSuccess = payload => ({
  type: UPDATE_CUSTOMER_SUCCESS,
  payload
});

export default (customer, customerTableData) => async (dispatch, getState) => {
  if (!(customer.Name) || customer.Name.trim() === "" || !(customer.Organisation.ID)) {
    dispatch(showNotification("Required fields must NOT be empty", "error"))
    return new Error()
  }

  dispatch(updateCustomerRequest());

  const query = odata({ service: getServiceUrl() }).resource(RESOURCES.Customers, customer.ID);
  const errorOrResult = await query.patch({ ...customer, Organisation: { ID: customer.Organisation.ID } }, {
    headers: {
      Authorization: `Bearer ${getState().user.token}`,
      ...getDefaultHeader()
    }
  })
    .then(resp => resp)
    .then(res => {
      const ok = res.statusCode <= 299 && res.statusCode >= 200;

      if (res.statusCode === 500) {
        const errorKey = "GENERAL_SERVER_ERROR";
        return new Error(errorKey);
      } else if (!ok) {
        const response = res.toJSON()
        const error = JSON.parse(response.body).Error
        const errorKey = res.statusCode === 401 ? `401: ${error.Details[0].Message}` : `${error.Details[0].Message}`;
        console.log("update customer api error", response);
        return new Error(errorKey);
      } else {
        const payload = customer;
        payload.tableData = customerTableData;
        return payload;
      }
    })
    .catch((error) => {
      console.error('Error:', error);
      dispatch(showNotification("Request probably timed out.", "error"))
    });

  if (errorOrResult instanceof Error) {
    dispatch(updateCustomerError(UPDATE_CUSTOMER_ERROR, errorOrResult.message));
    if (errorOrResult.message.split(":")[0] === "401") {
      dispatch(tokenExpired());
      dispatch(showNotification(errorOrResult.message.split(":")[1], "error"))
    }
    console.log("CODE ERROR: ", errorOrResult.message);
    dispatch(showNotification(errorOrResult.message.split(",")[1], "error"))
    return errorOrResult;
  } else {
    dispatch(showNotification("SUCCESSFUL_SAVE", "success"))
  }

  dispatch(updateCustomerSuccess(errorOrResult));

  return errorOrResult;
};
